module.exports = __webpack_public_path__ + "878b10430eb7455eccbf266c6d79fd87.png";